<template>
  <div>
    <sidebar></sidebar>
    <topbar></topbar>
    <edit></edit>
    <modal-code></modal-code>
    <modal-delete-step></modal-delete-step>
    <modal-duplicate-step></modal-duplicate-step>
  </div>
</template>

<script>
import Sidebar from './components/edit/sidebar/Main.vue';
import Topbar from './components/edit/topbar/Main.vue';
import Edit from './components/edit/canvas/Main.vue';
import ModalCode from './components/modal/Code.vue';
import ModalDeleteStep from './components/modal/DeleteStep.vue';
import ModalDuplicateStep from './components/modal/DuplicateStep.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Sidebar,
    Topbar,
    Edit,
    ModalCode,
    ModalDeleteStep,
    ModalDuplicateStep,
  },
  computed: {
    ...mapGetters([
      'showKlickpagesHeader',
    ]),
  },
  created() {
    this.$store.dispatch('boxGet')
      .then(() => {
        this.$store.dispatch('stepConfigRequest');
      });
    this.updateKlickpagesHeaderShowStatus(false);
  },
  destroyed() {
    this.updateKlickpagesHeaderShowStatus(true);
  },
  methods: {
    ...mapActions([
      'updateKlickpagesHeaderShowStatus',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** Edit.vue?4d76ec0a
 **/